import { render, staticRenderFns } from "./CeoMediaNews.vue?vue&type=template&id=66a6b77a&scoped=true&"
import script from "./CeoMediaNews.vue?vue&type=script&lang=js&"
export * from "./CeoMediaNews.vue?vue&type=script&lang=js&"
import style0 from "./CeoMediaNews.vue?vue&type=style&index=0&id=66a6b77a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a6b77a",
  null
  
)

export default component.exports